<template>
  <modal
    :show.sync="modalOpen"
    modalClasses="wide-modal"
    bodyClasses="no-top-padding"
  >
    <h4
      slot="header"
      class="modal-title"
      id="modal-title-default"
    >
      Import Players
    </h4>
    <div class="row">
      <div class="col-5">
        <base-input
          label="Game"
        >
          <Multiselect
            :options="livegames"
            trackBy="id"
            label="name"
            class="width-full"
            v-model="selectedGame"
          />
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4>
          Players in Game
        </h4>
        <PickerList
          :items="availablePlayers"
          v-model="selectedGamePlayers"
        />
      </div>
      <div class="col-1 vertical-align-center">
        <base-button
          type="secondary"
          class="mr-0 full-width"
          @click="addAllPlayersToFinalList"
        >
          <i class="fa fa-angle-double-right" />
        </base-button>
        <base-button
          type="secondary"
          class="mt-3 mr-0 full-width"
          @click="addPlayersToFinalList"
        >
          <i class="fa fa-angle-right" />
        </base-button>
        <base-button
          type="secondary"
          class="mt-3 mr-0 full-width"
          @click="removePlayersFromFinalList"
        >
          <i class="fa fa-angle-left" />
        </base-button>
        <base-button
          type="secondary"
          class="mt-3 mr-0 full-width"
          @click="removeAllPlayersFromFinalList"
        >
          <i class="fa fa-angle-double-left" />
        </base-button>
      </div>
      <div class="col">
        <h4>
          Players to Import
        </h4>
        <PickerList
          :items="playersToImport"
          v-model="selectedPlayersToImport"
        />
      </div>
    </div>
    <template slot="footer">
      <base-button
        type="link"
        @click="onClose"
      >
        Cancel
      </base-button>
      <base-button
        type="success"
        class="ml-auto"
        :disabled="loading"
        @click="importPlayers"
      >
        Save
      </base-button>
    </template>
  </modal>
</template>
<script>
import Multiselect from 'vue-multiselect';
import PickerList from '@/components/PickerList.vue';
import ErrorHandler from '@/helpers/AuthError';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'ImportPlayersModal',
  props: {
    open: Boolean,
    game: Object,
  },
  components: {
    Multiselect,
    PickerList,
  },
  data() {
    return {
      loading: false,
      livegames: [],
      selectedGame: null,
      selectedGamePlayers: [],
      playersToImport: [],
      selectedPlayersToImport: [],
    };
  },
  mounted() {
    this.getAllGames();
  },
  computed: {
    modalOpen: {
      get() {
        return this.open;
      },
      set() {
        this.selectedGame = null;
        this.selectedGamePlayers = [];
        this.playersToImport = [];
        this.selectedPlayersToImport = [];
        this.$emit('close');
      },
    },
    availablePlayers() {
      const options = [];

      if (!this.selectedGame) {
        return [];
      }

      this.selectedGame.liveteams.forEach((team) => {
        let playerSelected = false;
        this.playersToImport.forEach((player) => {
          if (parseInt(team.id, 10) === parseInt(player.id, 10)) {
            playerSelected = true;
          }
        });
        if (!playerSelected) {
          options.push(team);
        }
      });

      return options;
    },
  },
  watch: {
    selectedGame() {
      console.log(this.selectedGame);
    },
  },
  methods: {
    getAllGames() {
      this.axios
        .get('/livegames', {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.livegames = response.data;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    addPlayersToFinalList() {
      this.playersToImport.push(...this.selectedGamePlayers);
      this.selectedGamePlayers = [];
    },
    addAllPlayersToFinalList() {
      this.playersToImport.push(...this.availablePlayers);
      this.selectedGamePlayers = [];
    },
    removePlayersFromFinalList() {
      this.selectedPlayersToImport.forEach((selectedPlayer) => {
        this.playersToImport.forEach((player, index) => {
          if (parseInt(selectedPlayer.id, 10) === parseInt(player.id, 10)) {
            this.playersToImport.splice(index, 1);
          }
        });
      });

      this.selectedPlayersToImport = [];
    },
    removeAllPlayersFromFinalList() {
      this.selectedPlayersToImport = [];
      this.playersToImport = [];
    },
    onClose() {
      this.selectedGame = null;
      this.selectedGamePlayers = [];
      this.playersToImport = [];
      this.selectedPlayersToImport = [];
      this.$emit('close');
    },
    importPlayers() {
      const playerIds = [];
      this.playersToImport.forEach((player) => {
        playerIds.push(player.id);
      });

      this.axios
        .post(`/livegames/${this.game.id}/import`, { players: playerIds }, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.$emit('importedTeams', response.data);
          this.onClose();
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.full-width {
  width: 4rem;
}
</style>
<style lang="scss">
.wide-modal {
  max-width: 900px;
}
.no-top-padding {
  padding-top: 0;
}
.vertical-align-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
}

.multiselect{
  min-height: 43px;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
  border: 0 !important;
  border-radius: 0.375rem;

  .multiselect__tags{
    min-height: 43px;
    padding-top: 12px;
    border: 0;
    color:#8898aa;
  }

  .multiselect__select{
    padding-top: 13px;
  }
}
</style>
